export enum ECardTypeTemplateId {
  Products = 'products',
  Places = 'places',
  People = 'people',
  Pictures = 'pictures',
}

export type TCardTypeTagColor =
  | 'gray'
  | 'white'
  | 'red'
  | 'orange'
  | 'green'
  | 'blue'
  | 'darkBlue'
  | 'yellow'
  | 'lime'
  | 'sky'
  | 'cyan'
  | 'teal'
  | 'purple'
  | 'pink'
  | 'rose'
  | 'brown'
  | 'black';

export type TCardTypeTag = {
  enabled: boolean;
  text: string;
  color: TCardTypeTagColor;
};

export enum ECardTypeActionType {
  Text = 'text',
  Uri = 'uri',
}

export type TCardTypeActionType = ECardTypeActionType;

export type TCardTypeAction = {
  enabled: boolean;
  label: string;
  actionType: TCardTypeActionType | '';
  uri?: string;
  text?: string;
};

export type TCardTypeDescription = {
  enabled: boolean;
  text: string;
};

export type TCardTypePrice = {
  enabled: boolean;
  /** 項目名。空のときは金額のみを表示する */
  label?: string;
  currency: string;
  value: string;
};

export type TCardTypeAddress = {
  enabled: boolean;
  text: string;
};

export type TCardTypeAdditionalInfoType = 'Hours' | 'Price';

export type TCardTypeAdditionalInfo = {
  enabled: boolean;
  infoType: TCardTypeAdditionalInfoType;
  text: string;
};

/** Multi-image slots (Products / Places): A = main left, B/C = right stack */
export type TCardTypeImages = {
  a?: string;
  b?: string;
  c?: string;
};

export type TCardTypeCard = {
  imageUrl?: string;
  defaultImageUrl?: string;
  images?: TCardTypeImages;
  imageCount?: 1 | 2 | 3;
  header?: string;
  name?: string;
  description?: TCardTypeDescription;
  tag?: TCardTypeTag;
  tags?: [TCardTypeTag, TCardTypeTag, TCardTypeTag];
  price?: TCardTypePrice;
  /** 2つ目の価格。未設定のカードは従来どおりpriceのみ表示する */
  price2?: TCardTypePrice;
  address?: TCardTypeAddress;
  additionalInfo?: TCardTypeAdditionalInfo;
  actions: TCardTypeAction[];
  isClosingCard?: boolean;
  /** @deprecated Legacy fields — kept for API compat */
  title?: string;
  text?: string;
};

export type TCardTypeMessagePayload = {
  altText: string;
  templateId: ECardTypeTemplateId;
  cards: TCardTypeCard[];
};

export type TCardTypeTemplate = {
  id: ECardTypeTemplateId;
  label: string;
  description: string;
};
